import { Routes, Route } from "react-router-dom";

import EnderecoFiscal from "./pages/enderecoFiscal/Index";
import Login from "./pages/login/Index";
import Dashboard from "./pages/dashboard/Index";
import Assinaturas from "./pages/assinaturas/Index";
import Descontos from "./pages/descontos/Index";
import DescontosUsados from "./pages/descontosUsados/Index";
import TermosDeUso from "./pages/termosDeUso/Index";
import Planos from "./pages/planos/Index";
import Usuarios from "./pages/usuarios/Index";
import Admins from "./pages/usuarios/components/Admins";
import EsqueceuSenha from "./pages/esqueceuSenha/Index";
import Leads from "./pages/dashboard/components/Leads";
import EmitirNota from "./pages/emitirNota/Index";
import PerfilUsuario from "./pages/emitirNota/components/PerfilUsuario";
import PoliticaDePrivacidade from "./pages/politicaDePrivacidade/Index";
import LeadsLandingPage from "./pages/leadsLandingPage/Index";
import Obrigacoes from "./pages/obrigacoes/Index";
import ImportarGuias from "./pages/obrigacoes/components/ImportarGuias";
import DetalhesImportacao from "./pages/obrigacoes/components/DetalhesImportacao";
import ContratoPlano from "./pages/contratoPlano/Index";
import ContratoEnderecoFiscal from "./pages/contratoEnderecoFiscal/Index";

function App() {
	return (
		<Routes>
			<Route path="/" element={<Login />} />
			<Route path="/Dashboard" element={<Dashboard />} />
			<Route path="/Assinaturas" element={<Assinaturas />} />
			<Route path="/obrigacoes" element={<Obrigacoes />} />
			<Route path="/obrigacoes/importar-guias" element={<ImportarGuias />} />
			<Route path="/obrigacoes/detalhes-importacao/:idImportacao" element={<DetalhesImportacao />} />
			<Route path="/Descontos" element={<Descontos />} />
			<Route path="/DescontosUsados/:idDesconto" element={<DescontosUsados />} />
			<Route path="/TermosDeUso" element={<TermosDeUso />} />
			<Route path="/PoliticaDePrivacidade" element={<PoliticaDePrivacidade />} />
			<Route path="/contrato/plano" element={<ContratoPlano />} />
			<Route path="/contrato/enderecoFiscal" element={<ContratoEnderecoFiscal />} />
			<Route path="/Planos" element={<Planos />} />
			<Route path="/Usuarios" element={<Usuarios />} />
			<Route path="/Admins" element={<Admins />} />
			<Route path="/EsqueceuSenha" element={<EsqueceuSenha />} />
			<Route path="/Dashboard/Leads" element={<Leads />} />
			<Route path="/LeadsLandingPage" element={<LeadsLandingPage />} />
			<Route path="/EmitirNota" element={<EmitirNota />} />
			<Route path="/enderecoFiscal" element={<EnderecoFiscal />} />
			<Route path="/EmitirNota/Perfil/:idUsuario" element={<PerfilUsuario />} />
		</Routes>
	);
}

export default App;
